import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import db from "../FireBase/firebase"; 
import "../CSS/settingsModal.css";
import GrapheSettings from "./GrapheSettings";
import MesuresSettingsV2 from "./MesuresSettingsv2";
import BdSettings from "./bdSettings";
import { collectionActuelle } from "./bdSettings";

const nbPointsInitial = localStorage.getItem('nbPoints') || 30;

function SettingsModal({ isOpen, onClose, settings, handleSettingsChange }) {
  const [activeTab, setActiveTab] = useState("bd");

  const handleClose = () => {
    onClose();
    if(collectionActuelle !== localStorage.getItem('collectionName') || nbPointsInitial !== localStorage.getItem('nbPoints') || localStorage.getItem("reload")){ 
      localStorage.removeItem("reload");
      window.location.reload();
    }
  };

  useEffect(() => {
    const paramRef = ref(db, "parametres/mesures");
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const fetchedMesures = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const visible = childSnapshot.val().visible;
          fetchedMesures.push({ id: key, visible: visible });
        });
        // setMesures(fetchedMesures); // Supprimez cette ligne si vous n'utilisez pas 'mesures'
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );
  
    return () => unsubscribe();
  }, []); // Supprimez 'setMesures' de la liste des dépendances

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Paramètres</h2>

        <div className="tabs">
          <button className={activeTab === "bd" ? "active" : ""} onClick={() => setActiveTab("bd")}>
            BD
          </button>
          <button className={activeTab === "compteur" ? "active" : ""} onClick={() => setActiveTab("compteur")}>
            Compteur
          </button>
          <button className={activeTab === "temperature" ? "active" : ""} onClick={() => setActiveTab("temperature")}>
            Température
          </button>
          <button className={activeTab === "mesures" ? "active" : ""} onClick={() => setActiveTab("mesures")}>
            Mesures
          </button>

          <button className={activeTab === "graphiques" ? "active" : ""} onClick={() => setActiveTab("graphiques")}>
            Graphiques
          </button>
        </div>

        <div className="tab-content">
          {activeTab === "bd" && (
            <BdSettings />
          )}
          {activeTab === "compteur" && (
            <label>
              <input type="checkbox" checked={settings.compteur} onChange={() => handleSettingsChange("compteur")} /> Afficher Compteur
            </label>
          )}
          {activeTab === "temperature" && (
            <label>
              <input type="checkbox" checked={settings.temperature} onChange={() => handleSettingsChange("temperature")} /> Afficher Température
            </label>
          )}
          {activeTab === "mesures" && (
            <MesuresSettingsV2 onChange={handleSettingsChange}/>
          )}

          {activeTab === "graphiques" && (
            <GrapheSettings onChange={handleSettingsChange} />
          )}
        </div>

        <button onClick={handleClose} id="closeModalButton" title="Fermer les paramètres">Fermer</button>
      </div>
    </div>
  );
}

export default SettingsModal;